
import { Injectable } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private categoriesSource = new BehaviorSubject<any[]>([]);
  categories$ = this.categoriesSource.asObservable();

  private selectedCategorySource = new BehaviorSubject<any>(null);
  selectedCategory$ = this.selectedCategorySource.asObservable();


  constructor(private menuController: MenuController) {}

  async closeMenu() {
    await this.menuController.close('category-menu');
  }

  updateCategories(categories: any[]) {
    this.categoriesSource.next(categories);
  }

  selectCategory(category: any) {
    this.selectedCategorySource.next(category);
    this.closeMenu(); // Optionally close the menu after selection
  }
}